export default __webpack_public_path__ + "static/media/Bracers of the Exorcist.cf82dcc2.jpg";